{
    "title": "Templates",
    "subtitle": "Choose a diary setup"
}
